import React from 'react';
import PageWrapper from '../../components/UI/PageWrapper';
import CreateTeam from '../../components/Admin/CreateTeam';

const CreateTeamPage = () => (
  <PageWrapper>
    <CreateTeam />
  </PageWrapper>
);

export default CreateTeamPage;

